import { faker } from "@faker-js/faker";

import { IOption } from "@digital-services/ui";

import { AppRoleItem } from "../models/app-roles-models";

const possibleApps = [
  "Update Management",
  "Energy Management",
  "Experience Configurator"
];

const possibleAppRoles = ["Role 1", "Role 2", "Role 3", "Role 4", "Role 5"];

export const generateApplicationsAsOptions = () => {
  const apps: IOption[] = [];

  for (let index = 0; index < possibleApps.length; index++) {
    const element = possibleApps[index];
    apps.push({
      value: element, // TBD get application ID from Backend
      label: element
    });
  }

  return apps;
};

export const generateAppRolesAsOptions = () => {
  const roles: IOption[] = [];

  for (let index = 0; index < possibleAppRoles.length; index++) {
    const element = possibleAppRoles[index];
    roles.push({
      value: element, // TBD get role ID MAYBE from Backend
      label: element
    });
  }

  return roles;
};

export const getRandomAppRoleItem = (): AppRoleItem => {
  return {
    application: faker.helpers.arrayElement(possibleApps),
    roles: faker.helpers.arrayElements(possibleAppRoles),
    addedAt: faker.date.past()
  };
};

export const getRandomAppRolesArray = (length: number = 10): AppRoleItem[] => {
  const appRoles: AppRoleItem[] = [];

  for (let i = 0; i < length; i++) {
    appRoles.push(getRandomAppRoleItem());
  }

  return appRoles;
};
